<template>
  <v-card
    class="rounded-xl ma-2 pa-5"
    max-width="400px"
  >
    <v-card-title>
      Handbook
    </v-card-title>

    <v-checkbox
      v-model="service.handbookIncluded"
      label="Include"
      :disabled="$store.getters.loadingApp === 1"
    />
  </v-card>
</template>

<script>
export default {
  name: 'ServiceHandbook',

  props: {
    service: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>